import { render } from "./FileInputComponent.vue?vue&type=template&id=ddbee8b0&ts=true"
import script from "./FileInputComponent.vue?vue&type=script&lang=ts"
export * from "./FileInputComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__